import {
  LucideDollarSign,
  LucideListChecks,
  LucideListPlus,
  LucideSliders,
  LucideUsers,
} from 'lucide-react';

import { PricingLayout } from './_components/_layouts/PricingLayout';
import { CounterpartyGroupDetailView } from './_components/counterparty-groups/_CounterpartyGroupDetailView';
import { CounterpartyGroupListView } from './_components/counterparty-groups/_CounterpartyGroupListView';
import { CustomPriceListDetailView } from './_components/custom-price-lists/_CustomPriceListDetailView';
import { CustomPriceListView } from './_components/custom-price-lists/_CustomPriceListView';
import { DefaultPriceListView } from './_components/default-price-list/_DefaultPriceListView';
import { VariableListView } from './_components/variables/_VariableListView';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const basePath = '/pricing';

export const pricingRoutes = createModuleRoutes({
  root: {
    path: basePath,
    label: (t) => t.menu.pricing.root,
    icon: LucideDollarSign,
  },
  variables: {
    path: `${basePath}/variables`,
    label: (t) => t.menu.pricing.variables,
    icon: LucideSliders,
    component: VariableListView,
    requiredPermission: 'variableRead',
  },
  counterpartyGroups: {
    path: `${basePath}/groups`,
    label: (t) => t.menu.pricing.counterpartyGroups,
    icon: LucideUsers,
    component: CounterpartyGroupListView,
    requiredPermission: 'counterpartyGroupRead',
  },
  counterpartyGroupDetail: {
    path: `${basePath}/groups/:id`,
    component: CounterpartyGroupDetailView,
  },
  defaultPriceList: {
    path: `${basePath}/default`,
    label: (t) => t.menu.pricing.defaultPriceList,
    icon: LucideListChecks,
    component: DefaultPriceListView,
    requiredPermission: 'defaultPriceListRead',
  },
  customPriceLists: {
    path: `${basePath}/lists`,
    label: (t) => t.menu.pricing.customPriceLists,
    icon: LucideListPlus,
    component: CustomPriceListView,
    requiredPermission: 'customPriceListRead',
  },
  customPriceListDetail: {
    path: `${basePath}/lists/:id`,
    component: CustomPriceListDetailView,
  },
});

// prettier-ignore
const pricingNav = createModuleNav(($) =>
  $(pricingRoutes.root, [
    $(pricingRoutes.defaultPriceList),
    $(pricingRoutes.customPriceLists),
    $(pricingRoutes.customPriceListDetail),
    $(pricingRoutes.variables),
    $(pricingRoutes.counterpartyGroups),
    $(pricingRoutes.counterpartyGroupDetail),
  ]),
);

export const pricingModule = createAppModule({
  routes: pricingRoutes,
  nav: pricingNav,
  layout: PricingLayout,
  requiredEntitlement: 'pricing',
});
